import React from 'react';
import { grayMediumM, primaryHighlightM, grayDarkM } from 'web-ui-kit/colors';
var VARIANTS = {
  "default": {
    color: {
      "default": grayMediumM,
      selected: primaryHighlightM
    }
  },
  button: {
    color: {
      "default": grayDarkM,
      selected: grayDarkM
    }
  }
};

function LikeHeart(_ref) {
  var _ref$className = _ref.className,
      className = _ref$className === void 0 ? '' : _ref$className,
      _ref$isSelected = _ref.isSelected,
      isSelected = _ref$isSelected === void 0 ? false : _ref$isSelected,
      _ref$variant = _ref.variant,
      variant = _ref$variant === void 0 ? 'default' : _ref$variant;

  var selectedColor = function selectedColor() {
    return VARIANTS[variant].color.selected;
  };

  var unselectedColor = function unselectedColor() {
    return VARIANTS[variant].color["default"];
  };

  return (
    /*#__PURE__*/
    React.createElement("svg", {
      "aria-label": "like",
      role: "img",
      className: className,
      width: "16",
      viewBox: "0 0 16 15",
      fill: "none",
      xmlns: "http://www.w3.org/2000/svg"
    }, isSelected ?
    /*#__PURE__*/
    React.createElement(React.Fragment, null,
    /*#__PURE__*/
    React.createElement("path", {
      fillRule: "evenodd",
      clipRule: "evenodd",
      d: "M8 15C23.0852 4.57221 13.1446 -3.87044 8 1.84803C2.85535 -3.87044 -7.08521 4.57221 8 15Z" // eslint-disable-line
      ,
      fill: selectedColor()
    }),
    /*#__PURE__*/
    React.createElement("path", {
      fillRule: "evenodd",
      clipRule: "evenodd",
      d: "M7.00036 0.9487C1.72436 -2.82146 -6.15481 5.21535 8 15C22.1548 5.21535 14.2756 -2.82146 8.99964 0.9487C8.65285 1.19651 8.3173 1.49534 8 1.84803C7.6827 1.49534 7.34715 1.19651 7.00036 0.9487ZM8 13.1586C11.1096 10.8748 12.8701 8.78311 13.7521 7.05863C14.7046 5.19613 14.6087 3.83301 14.2236 2.99639C13.4995 1.42333 11.0779 0.669602 9.11513 2.85127L8 4.09078L6.88487 2.85127C4.92212 0.669602 2.50049 1.42333 1.77637 2.99639C1.39125 3.83301 1.29543 5.19613 2.24795 7.05863C3.12989 8.78311 4.8904 10.8748 8 13.1586Z" // eslint-disable-line
      ,
      fill: selectedColor()
    })) :
    /*#__PURE__*/
    React.createElement("path", {
      fillRule: "evenodd",
      clipRule: "evenodd",
      d: "M7.00036 0.9487C1.72436 -2.82146 -6.15481 5.21535 8 15C22.1548 5.21535 14.2756 -2.82146 8.99964 0.9487C8.65285 1.19651 8.3173 1.49534 8 1.84803C7.6827 1.49534 7.34715 1.19651 7.00036 0.9487ZM8 13.1586C11.1096 10.8748 12.8701 8.78311 13.7521 7.05863C14.7046 5.19613 14.6087 3.83301 14.2236 2.99639C13.4995 1.42333 11.0779 0.669602 9.11513 2.85127L8 4.09078L6.88487 2.85127C4.92212 0.669602 2.50049 1.42333 1.77637 2.99639C1.39125 3.83301 1.29543 5.19613 2.24795 7.05863C3.12989 8.78311 4.8904 10.8748 8 13.1586Z" // eslint-disable-line
      ,
      fill: unselectedColor()
    }))
  );
}

export default LikeHeart;